export enum InsuranceCompanyCode {
  AXA_DIRECT = 'AXA_DIRECT',
  BEESAFE = 'BEESAFE',
  BENEFIA = 'BENEFIA',
  DIRECT = 'DIRECT',
  ERGO_HESTIA = 'ERGO_HESTIA',
  EUROINS = 'EUROINS',
  GENERALI = 'GENERALI',
  LINK4 = 'LINK4',
  MTU = 'MTU',
  PROAMA = 'PROAMA',
  OMINIMO = 'OMINIMO',
  TRASTI = 'TRASTI',
  TUZ = 'TUZ',
  UNIQA = 'UNIQA',
  PEVNO = 'PEVNO',
  ALLIANZ = 'ALLIANZ',
}

